"use client";

import { useMemo } from "react";
import { useSelector } from "react-redux";
import type { RootState } from "@/app/store/store";
import NoticeDialogDesktop from "./NoticeDialogDesktop";
import NoticeDrawerMobile from "./NoticeDrawerMobile";
import type { NoticeDialogProps } from "./NoticeTypes";
import useAppNoticeHandler from "@/hooks/useAppNoticeHandler";
import { useIsMobile } from "@/hooks/use-mobile";

export default function AppNoticeDialog() {
  const appNotice = useSelector((state: RootState) => state.reparoly.appNotice);
  const { handleNoticeAction, clearNotice } = useAppNoticeHandler();
  const isMobile = useIsMobile();

  const errorPayload = useMemo(
    () => ({
      message: appNotice.message || "",
      details: appNotice.details || "",
      errors: Object.keys(appNotice.validationErrors || {}).length
        ? appNotice.validationErrors
        : appNotice.errors || {},
      endpointName: appNotice.endpointName || "",
      status: appNotice.status ?? null,
    }),
    [appNotice.details, appNotice.errors, appNotice.endpointName, appNotice.message, appNotice.status, appNotice.validationErrors],
  );

  const handleOpenChange = (open: boolean) => {
    if (!open) clearNotice();
  };

  const noticeProps: NoticeDialogProps = {
    open: Boolean(appNotice.open),
    onOpenChange: handleOpenChange,
    error: errorPayload,
    variant: appNotice.variant || "warning",
    onConfirm: () => handleNoticeAction(appNotice),
  };

  if (isMobile) {
    return <NoticeDrawerMobile {...noticeProps} />;
  }

  return <NoticeDialogDesktop {...noticeProps} />;
}
